import { useAuth } from '@/services/auth/context';
import { SafeNavigate } from '@/services/router/safe-navigate';

/**
 * Renders children only when the account's plan_slug is not in the
 * excluded list. Otherwise redirects to the available plans page.
 */
export function PlanGuard({ excludedPlans, children }: { excludedPlans: string[]; children: React.ReactNode }) {
  const { account } = useAuth();

  if (excludedPlans.includes(account.plan_slug)) {
    return (
      <SafeNavigate to="/settings/billing/available-plans/journeys" options={{ shouldReplaceHistoryEntry: true }} />
    );
  }

  return <>{children}</>;
}
